import { t } from '~/components/I18n';
import basket from '~/components/Icon/basket.png';
import { QuickMenuItem } from '~/components/Quick/Menu/QuickMenuItem';

export type ResellQuickMenuItemProps = {
  className?: string;
};

export const ResellQuickMenuItem = ({ className }: ResellQuickMenuItemProps) => (
  <QuickMenuItem className={className} image={basket} label={t('citizen_quick_resell')} />
);
